import { Component, HostListener, Input } from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { NavigationItem } from '@models/navigation';
import { IconComponent } from '@shared/icon/icon.component';

@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrl: './navigation-item.component.scss',
  imports: [RouterLinkActive, RouterLink, IconComponent],
})
export class NavigationItemComponent {
  @Input({ required: true }) navigationItem: NavigationItem;
  @Input() isActive = false;
  @Input() isTrimmed = false;
  isHovered = false;

  @HostListener('mouseenter')
  onMouseEnter() {
    this.isHovered = true;
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.isHovered = false;
  }
}
